import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import {
  faFileContract,
  faFileDownload,
  faFileExport,
  faFileUpload,
  faPen,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from '@mui/material';
import axios from 'axios';
import { downloadFile } from 'utils/downloadHelper';
import useAuthz from 'hooks/useAuthz';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router';
import { ClipLoader } from 'react-spinners';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import MyButton from '../../components/Layout/MyButton';
import TopBar from '../../components/Layout/TopBar';
import { logError } from '../../components/Utils/FormatData';
import { FACTURATION_TYPE } from '../../constants/enum';
import { URL_API } from '../../utils/globalConfig';

const css = {
  container: { height: '60%', width: '40%', backgroundColor: 'white', borderRadius: '5px' },
  fullRow: { height: '100%', width: '100%', alignItems: 'center' },
  row: { height: 'calc(100% - 110px)', flexDirection: 'column', justifyContent: 'normal' },
  rowValidation: { height: '60px', flexDirection: 'column', justifyContent: 'normal', alignItems: 'flex-end' },
  contractBtn: {
    color: 'rgb(255, 255, 255)',
    height: '95%',
    backgroundColor: '#f18d2d',
    width: '20%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  contractBtnIcon: { fontSize: '50px' },
  contractBtnLabel: {
    textAlign: 'center', textDecoration: 'none', fontSize: 14, fontWeight: 700, margin: '10px', cursor: 'pointer',
  },
  rowLabel: {
    fontSize: '20px',
    marginBottom: '20px',
    padding: '5px',
    paddingLeft: '40px',
    marginTop: '5px',
    marginLeft: '12px',
    borderBottomLeftRadius: '50px',
    boxShadow: 'rgba(0, 148, 202, 0.4) 0px 3px 4px',
  },
};

const ModalDisplayDevisPDF = (props) => {
  const { openModal, setOpenModal, setOpenModalXml, setOpenModal5, color, facturation_id, type, setReloadData } = props;
  const [authz, user, profil] = useAuthz();
  const fileInputRef = React.useRef();
  const alert = useAlert();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [facturation, setFacturation] = useState(null);
  const [documentId, setDocumentId] = useState(null);
  const [sapId, setSapId] = useState(null);
  const [devisSigned, setDevisSigned] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  //#region useEffect

  // Fonction de nettoyage
  useEffect(() => {
    return () => {
      setFacturation(null);
      setIsLoading(false);
    };
  }, []);

  // Initialisation du composant
  useEffect(() => {
    if (profil.profil === 6) {
      alert.error('Vous n\'êtes pas autorisé à accéder à cette page');
      navigate('/');
    }
  }, []);

  useEffect(() => {
    if (facturation && openModal) document.title = facturation.type_facturation === FACTURATION_TYPE.DEVIS ? 'TE - Consultation de devis' : 'TE - Consultation de la facture';
  }, [facturation]);

  useEffect(async () => {
    if (openModal)
        await fetchLoad();
  }, [openModal]);


  useEffect(async () => {
      if (facturation)
        await apiGetDocument();
  }, [facturation])
  //#endregion

  //#region Fonctions

  const handleCloseModal = () => {
    setIsLoading(false);
    setOpenModal(false);
  };
  const onRequestPassContractBtnClick = () => {
    navigate('/facturation/' + facturation.type_facturation + '?id=' + facturation_id);
  };
  const onOpenXmlBtnClick = () => {
    setOpenModal(false);

    setTimeout(() => {
      setOpenModalXml(true);
    }, 100);
  };
  const onOpenEditDevisBtnClick = () => {
    setOpenModal(false);

    setTimeout(() => {
      setOpenModal5(true);
    }, 100);
  };
  const onOpenBtnClick = () => {
    fileInputRef.current.click();
  };
  const onFileChange = (event) => {
    let file = fileInputRef.current.files[0];
    let reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onloadend = function() {
      let base64data = reader.result.split(',')[1];

      axios({
        method: 'post', url: `${URL_API}/facturation/save-document`, data: {
          id: sapId || 0,
          data: base64data,
          fileName: 'fichier SAP facture n° [' + facturation_id + ']',
          mimeType: 'application/pdf',
        }, params: { id: facturation_id, type: 'SAP', userAction: user.user_id }
      })
        .then((response) => {
          alert.removeAll();
          alert.success(`Le ficher SAP a été sauvegardé`);
          setReloadData(true);
        })
        .catch((error) => {
          alert.removeAll();
          alert.error(error.message);
        });
    };
  };

  //#endregion

  //#region

  const fetchLoad = () => {
    axios({ method: 'get', url: `${URL_API}/facturation/fact-by-id`, params: { id: facturation_id } })
      .then((response) => {
        setFacturation(response.data);
      })
      .catch((error) => {
        alert.removeAll();
        alert.error(error.message);
      });
  };

  const apiGetDocument = () => {
    let documentFacturationRequest = axios({
      method: 'get',
      url: URL_API + '/facturation/verifier-document-facturation',
      params: { requestId: facturation?.dossier.id, type: facturation?.type_facturation.toUpperCase(), facturationId: facturation.id ?? 0}
    });
    let documentSapRequest = axios({
      method: 'get',
      url: URL_API + '/facturation/verifier-document-facturation',
      params: { requestId: facturation.dossier.id, type: 'SAP', facturationId: facturation.id ?? 0}
    });
    let documentDevisSignedRequest = axios({
      method: 'get',
      url: URL_API + '/facturation/verifier-document-facturation',
      params: { requestId: facturation.dossier.id, type: 'DEVIS_SIGNED', facturationId: facturation.id ?? 0}
    });

    Promise.all([documentFacturationRequest, documentSapRequest, documentDevisSignedRequest]).then((response) => {
      setDocumentId(response[0].data);
      setSapId(response[1].data);
      setDevisSigned(response[2].data);
      setIsLoading(false);
    })
      .catch((error) => {
        setIsLoading(false);
        logError(alert, error);
      });
  };

  //#endregion

  return <Modal open={openModal} style={{ display: 'flex' }} disableEscapeKeyDown={true}>
    <div className='modal' style={{ width: '110vw', height: '106vh', top: '-40px', left: '-100px' }}>
      {isLoading && <div className='row' style={css.fullRow}>
        <ClipLoader color='#0094ca' loading={isLoading} size={75}
                    css={'display: flex; margin: 25px;justify-content: center;'} />
      </div>}
      {!isLoading && <div style={{ ...css.container, height: '70%' }}>
        <TopBar
          title={facturation && `${facturation.type_facturation === FACTURATION_TYPE.DEVIS ? 'Devis' : 'Facture'} [N°${facturation_id}]`}
          className='topbar-contenu' color={'#f18d2d'}
          buttons={<div className='topbar-buttons'>
            <MyButton onClick={() => handleCloseModal()} label='Fermer' icon={faXmark} sx={{backgroundColor: '#b76618 !important'}}/>
          </div>}
        />
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          alignItems: 'center',
          height: '92%',
          width: '100%',
        }}>
          {facturation && (profil.profil === 1 || profil.profil === 2 || profil.profil === 3 || profil.profil === 5) && <>
            <div style={css.fullRow}>

              {(profil.profil === 1 || profil.profil === 2) &&
                facturation.type_facturation === FACTURATION_TYPE.FACTURE &&
                <div style={css.rowLabel}>
                  <label style={{ fontWeight: 'bold' }}>Fichiers GATE</label>
                </div>}
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: '80%',
                justifyContent: 'space-around',
                marginTop: ((profil.profil === 5 || profil.profil === 3) || facturation.type_facturation === FACTURATION_TYPE.DEVIS) ? 'calc(6vh + 5px)' : '0',
              }}>
                {((profil.profil === 1 || profil.profil === 2) && (facturation.type_facturation === FACTURATION_TYPE.DEVIS && (facturation.elements_factures.status.statutDevis !== 'accepted' && facturation.elements_factures.status.statutDevis !== 'refused'))) && <div className='icon-opacity' style={css.contractBtn}
                                                                      title={`Créer ${facturation.type_facturation === FACTURATION_TYPE.DEVIS ? 'devis' : 'facture'}`}
                                                                      onClick={onRequestPassContractBtnClick}>
                  <FontAwesomeIcon style={css.contractBtnIcon} icon={faFilePdf} />
                  <label style={css.contractBtnLabel}>{'Créer'}</label>
                </div>}

                {facturation && documentId && <a className='icon-opacity' style={{...css.contractBtn, cursor: 'pointer'}}
                                                 title={`Télécharger ${facturation.type_facturation === FACTURATION_TYPE.DEVIS ? 'devis' : 'facture'}`}
                                                 onClick={() => downloadFile(URL_API + '/facturation/telecharger-document-facturation?requestId=' + facturation.dossier.id + '&type=' + (facturation.type_facturation === FACTURATION_TYPE.DEVIS ? 'DEVIS' : 'FACTURE') + '&facturationId=' + facturation.id)}>
                  <FontAwesomeIcon style={css.contractBtnIcon} icon={faFileDownload} />
                  <label
                    style={css.contractBtnLabel}>{'Télécharger ' + (facturation.type_facturation === FACTURATION_TYPE.DEVIS ? 'le devis' : 'le récapitulatif des éléments facturés')}</label>
                </a>}

                {devisSigned && facturation.type_facturation === FACTURATION_TYPE.DEVIS && facturation.elements_factures.status.statutDevis === 'accepted' &&
                    <a className='icon-opacity' style={{...css.contractBtn, cursor: 'pointer'}} title={`Télécharger le devis signé`}
                        onClick={() => downloadFile(URL_API + '/facturation/telecharger-document-facturation?requestId=' + facturation.dossier.id + '&type=DEVIS_SIGNED' + '&facturationId=' + facturation.id)}>
                      <FontAwesomeIcon style={css.contractBtnIcon} icon={faFileDownload} />
                      <label style={css.contractBtnLabel}>{'Télécharger le devis signé'}</label>
                    </a>
                }

                {(profil.profil === 5 && facturation.type_facturation === FACTURATION_TYPE.DEVIS && (facturation.elements_factures.status.statutDevis !== 'accepted' && facturation.elements_factures.status.statutDevis !== 'refused')) &&
                  <div className='icon-opacity' style={css.contractBtn}
                       title={`Accepter / Refuser le devis`}
                       onClick={onOpenEditDevisBtnClick}>
                    <FontAwesomeIcon style={css.contractBtnIcon} icon={faFileContract} />
                    <label style={css.contractBtnLabel}>{'Accepter / Refuser le devis'}</label>
                  </div>
                }
              </div>
            </div>

            {(profil.profil === 1 || profil.profil === 2) && facturation.type_facturation === FACTURATION_TYPE.FACTURE &&
              <div style={css.fullRow}>
                <div style={css.rowLabel}>
                  <label style={{ fontWeight: 'bold' }}>Fichiers SAP</label>
                </div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  height: '80%',
                  justifyContent: 'space-around',
                }}>
                  {facturation &&
                  <div className='icon-opacity' style={css.contractBtn}
                       title={`Générer XML SAP`}
                       target={'_blank'} onClick={onOpenXmlBtnClick}>
                    <FontAwesomeIcon style={css.contractBtnIcon} icon={faFileExport} />
                    <label style={css.contractBtnLabel}>{'Générer XML SAP'}</label>
                  </div>
                  }
                  <div className='icon-opacity' style={css.contractBtn}
                       title={'Téléverser PDF SAP'} onClick={onOpenBtnClick}>
                    <FontAwesomeIcon style={css.contractBtnIcon} icon={faFileUpload} />
                    <label style={css.contractBtnLabel}>{'Téléverser PDF SAP'}</label>
                    <input style={{ display: 'none' }} ref={fileInputRef} type='file' accept={['application/pdf']}
                           onChange={onFileChange} />
                  </div>

                  {facturation &&
                      <>
                        <a className='icon-opacity' style={{...css.contractBtn, cursor: 'pointer'}}
                           title={`Télécharger PDF SAP`}
                           onClick={() => downloadFile(URL_API + '/facturation/telecharger-document-facturation?requestId=' + facturation.dossier.id + '&type=SAP' + '&facturationId=' + facturation.id)}>
                          <FontAwesomeIcon style={css.contractBtnIcon} icon={faFilePdf} />
                          <label style={css.contractBtnLabel}>{'Télécharger PDF SAP'}</label>
                        </a>
                      </>
                  }
                </div>
              </div>}
          </>}
        </div>
      </div>}
    </div>
  </Modal>;
};

export default ModalDisplayDevisPDF;
